const MetaMask = ({ ...props }) => (
  <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <path
      d='M21.9127 2L13.316 8.37777L14.9126 4.61504L21.9127 2Z'
      fill='#E17726'
      stroke='#E17726'
      strokeWidth='0.0850142'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M2.08728 2L10.6057 8.43813L9.08735 4.61504L2.08728 2Z'
      fill='#E27625'
      stroke='#E27625'
      strokeWidth='0.0850142'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M18.8225 16.7848L16.5356 20.2891L21.4291 21.6349L22.8275 16.8622L18.8225 16.7848Z'
      fill='#E27625'
      stroke='#E27625'
      strokeWidth='0.0850142'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M1.18115 16.8622L2.57113 21.6349L7.46455 20.2891L5.18617 16.7848L1.18115 16.8622Z'
      fill='#E27625'
      stroke='#E27625'
      strokeWidth='0.0850142'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M7.197 10.8636L5.83337 12.9269L10.6843 13.1428L10.5202 7.92041L7.197 10.8636Z'
      fill='#E27625'
      stroke='#E27625'
      strokeWidth='0.0850142'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M16.8033 10.8635L13.4283 7.85999L13.316 13.1428L18.167 12.9268L16.8033 10.8635Z'
      fill='#E27625'
      stroke='#E27625'
      strokeWidth='0.0850142'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M7.46472 20.289L10.3909 18.8642L7.87024 16.897L7.46472 20.289Z'
      fill='#E27625'
      stroke='#E27625'
      strokeWidth='0.0850142'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M13.6093 18.8642L16.5354 20.289L16.1299 16.897L13.6093 18.8642Z'
      fill='#E27625'
      stroke='#E27625'
      strokeWidth='0.0850142'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M16.5354 20.2891L13.6093 18.8643L13.8422 20.772L13.8167 21.5745L16.5354 20.2891Z'
      fill='#D5BFB2'
      stroke='#D5BFB2'
      strokeWidth='0.0850142'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M7.46472 20.2891L10.1835 21.5745L10.1665 20.772L10.3909 18.8643L7.46472 20.2891Z'
      fill='#D5BFB2'
      stroke='#D5BFB2'
      strokeWidth='0.0850142'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M10.2352 15.6362L7.80127 14.9204L9.51856 14.1349L10.2352 15.6362Z'
      fill='#233447'
      stroke='#233447'
      strokeWidth='0.0850142'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M13.7649 15.6362L14.4816 14.1349L16.2074 14.9204L13.7649 15.6362Z'
      fill='#233447'
      stroke='#233447'
      strokeWidth='0.0850142'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M7.46466 20.2891L7.88718 16.7848L5.18628 16.8622L7.46466 20.2891Z'
      fill='#CC6228'
      stroke='#CC6228'
      strokeWidth='0.0850142'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M16.113 16.7848L16.5356 20.2891L18.8224 16.8622L16.113 16.7848Z'
      fill='#CC6228'
      stroke='#CC6228'
      strokeWidth='0.0850142'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M18.167 12.9268L13.316 13.1428L13.7649 15.6362L14.4816 14.1349L16.2074 14.9204L18.167 12.9268Z'
      fill='#CC6228'
      stroke='#CC6228'
      strokeWidth='0.0850142'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M7.80146 14.9204L9.51874 14.1349L10.2354 15.6362L10.6843 13.1428L5.83337 12.9268L7.80146 14.9204Z'
      fill='#CC6228'
      stroke='#CC6228'
      strokeWidth='0.0850142'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M5.83337 12.9268L7.87032 16.897L7.80146 14.9204L5.83337 12.9268Z'
      fill='#E27525'
      stroke='#E27525'
      strokeWidth='0.0850142'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M16.2074 14.9204L16.13 16.897L18.1669 12.9268L16.2074 14.9204Z'
      fill='#E27525'
      stroke='#E27525'
      strokeWidth='0.0850142'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M10.684 13.1428L10.2351 15.6363L10.8047 18.5795L10.9254 14.7045L10.684 13.1428Z'
      fill='#E27525'
      stroke='#E27525'
      strokeWidth='0.0850142'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M13.3159 13.1428L13.083 14.696L13.1952 18.5795L13.7648 15.6363L13.3159 13.1428Z'
      fill='#E27525'
      stroke='#E27525'
      strokeWidth='0.0850142'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M13.7648 15.6362L13.1952 18.5794L13.6092 18.8642L16.1299 16.897L16.2072 14.9204L13.7648 15.6362Z'
      fill='#F5841F'
      stroke='#F5841F'
      strokeWidth='0.0850142'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M7.80127 14.9204L7.87013 16.897L10.3908 18.8642L10.8048 18.5794L10.2352 15.6362L7.80127 14.9204Z'
      fill='#F5841F'
      stroke='#F5841F'
      strokeWidth='0.0850142'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M13.817 21.5745L13.8425 20.7719L13.6274 20.5824H10.3731L10.1665 20.7719L10.1835 21.5745L7.46472 20.2891L8.41433 21.0652L10.3476 22.4034H13.6529L15.5861 21.0652L16.5357 20.2891L13.817 21.5745Z'
      fill='#C0AC9D'
      stroke='#C0AC9D'
      strokeWidth='0.0850142'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M13.6092 18.8642L13.1952 18.5794H10.8046L10.3906 18.8642L10.1661 20.7719L10.3727 20.5823H13.6271L13.8422 20.7719L13.6092 18.8642Z'
      fill='#161616'
      stroke='#161616'
      strokeWidth='0.0850142'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M22.2748 8.79264L22.9999 5.27135L21.9126 2L13.6093 8.16268L16.8032 10.8636L21.3166 12.1847L22.3096 11.0192L21.8777 10.7089L22.5681 10.0781L22.0418 9.66403L22.7321 9.13779L22.2748 8.79264Z'
      fill='#763E1A'
      stroke='#763E1A'
      strokeWidth='0.0850142'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M1 5.27135L1.73367 8.79264L1.2678 9.13779L1.95811 9.66403L1.43187 10.0781L2.12219 10.7089L1.69032 11.0192L2.68328 12.1847L7.19669 10.8636L10.3907 8.16268L2.08733 2L1 5.27135Z'
      fill='#763E1A'
      stroke='#763E1A'
      strokeWidth='0.0850142'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M21.3167 12.1848L16.8033 10.8636L18.1669 12.9269L16.13 16.8971L18.8224 16.8623H22.8274L21.3167 12.1848Z'
      fill='#F5841F'
      stroke='#F5841F'
      strokeWidth='0.0850142'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M7.19676 10.8636L2.68335 12.1848L1.18115 16.8623H5.18617L7.87007 16.8971L5.83313 12.9269L7.19676 10.8636Z'
      fill='#F5841F'
      stroke='#F5841F'
      strokeWidth='0.0850142'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M13.316 13.1428L13.6093 8.1627L14.9126 4.61505H9.0874L10.3907 8.1627L10.684 13.1428L10.7962 14.713L10.8047 18.5795H13.1953L13.2038 14.713L13.316 13.1428Z'
      fill='#F5841F'
      stroke='#F5841F'
      strokeWidth='0.0850142'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

export default MetaMask;
